const roleList = [{
    name: "周报",
    id:'1',
    roleKey:"WeeklyReport",
    children: [
        {
            name: "按个人查询（仅限所在组织机构及下级组织机构）",
            roleKey: "WeeklyReport_Search_ByUser_Scoped",
            id: "11",
        },
        {
            name: "按个人查询（所有人员）",
            roleKey: "WeeklyReport_Search_ByUser_All",
            id: "12",
        },
        {
            name: "按组织机构查询（仅限所在组织机构及下级组织机构）",
            roleKey: "WeeklyReport_Search_ByOrganization_Scoped",
            id: "13",
        },
        {
            name: "按组织机构查询（所有人员）",
            roleKey: "WeeklyReport_Search_ByOrganization_All",
            id: "14",
        }

    ]
},
{
    name: "项目管理",
    roleKey: "Project",
    id: "2",
    children: [
        {
            name: "基础数据配置（项目管理、项目类型等）",
            roleKey: "Project_Settings",
            id: "21",
        },

    ],
},
{
    name: "统计数据",
    roleKey: "Report",
    id: "3",
    children: [
        {
            name: "仅限所在组织机构及下级组织机构",
            roleKey: "Report_Scoped",
            id: "31",
        },
        {
            name: "所有人员",
            roleKey: "Report_All",
            id: "32",
        }
    ]
},
{
    name: "系统管理",
    roleKey: "Settings",
    id: "4",
    children: [
        {
            name: "组织机构、人员及角色",
            roleKey: "Settings_Organization",
            id: "41",
        },
        {
            name: "基础数据配置（日常工作、系统设置等）",
            roleKey: "Settings_BaseData",
            id: "42",
        }
    ]
}

];


export default roleList


// WEBPACK FOOTER //
// ./src/router/roleList.js